import type { Resolver } from 'cpool-schemas';
import { z } from 'zod';

import { schemaTemplatesDivisionMail } from '../tables';

type Arguments = {
    position?: number;
    divisionId?: string | null;
};

export const schemaTemplateResolver_ListByDivision = z.array(schemaTemplatesDivisionMail);

export type SchemaTemplateResolver_ListByDivision = z.infer<typeof schemaTemplateResolver_ListByDivision>;

export type TemplateResolver_ListByDivision = Resolver<Arguments, SchemaTemplateResolver_ListByDivision>;
